import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHeadphones = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.0001 20.3333C19.0609 20.3333 20.0784 19.9119 20.8285 19.1618C21.5787 18.4116 22.0001 17.3942 22.0001 16.3333V16.3333C22.0001 15.2725 21.5787 14.255 20.8285 13.5049C20.0784 12.7548 19.0609 12.3333 18.0001 12.3333V12.3333C17.6465 12.3333 17.3073 12.4738 17.0573 12.7239C16.8072 12.9739 16.6667 13.313 16.6667 13.6667V19C16.6667 19.3536 16.8072 19.6928 17.0573 19.9428C17.3073 20.1929 17.6465 20.3333 18.0001 20.3333Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 20.3333C4.93913 20.3333 3.92172 19.9119 3.17157 19.1618C2.42143 18.4116 2 17.3942 2 16.3333V16.3333C2 15.2725 2.42143 14.255 3.17157 13.5049C3.92172 12.7548 4.93913 12.3333 6 12.3333V12.3333C6.35362 12.3333 6.69276 12.4738 6.94281 12.7239C7.19286 12.9739 7.33333 13.313 7.33333 13.6667V19C7.33333 19.3536 7.19286 19.6928 6.94281 19.9428C6.69276 20.1929 6.35362 20.3333 6 20.3333Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66675 12.5609V11C4.67238 9.05682 5.4468 7.19482 6.82085 5.82077C8.1949 4.44672 10.0569 3.6723 12.0001 3.66667V3.66667C13.9433 3.6723 15.8053 4.44672 17.1793 5.82077C18.5534 7.19482 19.3278 9.05682 19.3334 11V12.5609"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHeadphones.displayName = 'SvgHeadphones';
export default SvgHeadphones;
